export const mensajesInbox = {
  title: "Nachrichten",

  noAccess: {
    description:
      "Für den Zugriff auf den Nachrichteneingang müssen Sie in den Kontoeinstellungen Ihre eigene WhatsApp-Business-Nummer verbunden haben.",
    connectButton: "WhatsApp verbinden",
  },

  search: {
    placeholder: "Nach Telefon oder Gast suchen...",
  },

  filters: {
    allProperties: "Alle Unterkünfte",
    searchProperty: "Unterkunft suchen...",
    filterTitle: "Nachrichten filtern",
    clearAll: "Filter löschen",
    removeOne: "„{filtro}“ entfernen",
    someActive: "{count} Filter",
  },

  tabs: {
    all: "Alle",
    unread: "Ungelesen",
    pinned: "Angeheftet",
    archived: "Archiviert",
    noReservation: "Ohne Buchung",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Andere OTA",
    unpaid: "Unbezahlt",
    paid: "Bezahlt",
    arrivingSoon: "Reisen bald an",
  },

  filterGroups: {
    chat: "Konversation",
    origin: "Herkunft",
    reservation: "Buchung",
  },

  list: {
    empty: "Keine Konversationen",
    noMessages: "Keine Nachrichten",
  },

  channels: {
    web: "Web",
    webConcierge: "Web-Concierge · Aufenthaltsportal",
    otaMessage: "Nachricht von {provider}",
  },

  chat: {
    placeholderSelect: "Wählen Sie eine Konversation, um zu beginnen",
    loading: "Konversation wird geladen...",
    dropToAttach: "Zum Anhängen hierher ziehen",
    emptyThread: "Noch keine Nachrichten in diesem Verlauf",
    notSent: "Nicht gesendet",
    sending: "Wird gesendet...",
  },

  sender: {
    guest: "Gast",
    you: "Sie",
    aiAgent: "KI-Agent",
  },

  media: {
    document: "Dokument",
    sharedLocation: "Geteilter Standort",
    attachment: "Anhang",
  },

  preview: {
    attachmentSent: "Anhang gesendet",
    messageSent: "Nachricht gesendet",
    attachmentReceived: "Anhang erhalten",
    newMessage: "Neue Nachricht",
  },

  mode: {
    aiAgent: "KI-Agent",
    manual: "Manuell",
  },

  automation: {
    disabledNotice:
      "Der KI-Agent ist für diese Unterkunft nicht aktiviert: Er antwortet nicht, Sie schreiben die Nachrichten.",
    aiActiveBanner:
      "Der KI-Agent antwortet diesem Gast automatisch.",
  },

  faq: {
    title: "Häufige Fragen",
  },

  composer: {
    placeholder: "Nachricht schreiben oder / verwenden, um eine Antwort einzufügen...",
    hint: "Enter zum Senden · Shift+Enter für eine neue Zeile",
  },

  actions: {
    newConversation: "Neue Konversation",
    options: "Optionen",
    attachFile: "Datei anhängen",
  },

  alt: {
    flag: "Flagge",
    sentImage: "Gesendetes Bild",
  },

  common: {
    file: "Datei",
    notAvailable: "Nicht verfügbar",
  },

  nights: "{count} Nacht | {count} Nächte",

  arrival: {
    pending: "Datum ausstehend",
    today: "Kommt heute an",
    tomorrow: "Kommt morgen an",
    yesterday: "Kam gestern an",
    inDays: "In {count} Tagen",
    daysAgo: "Kam vor {count} Tagen an",
  },

  reservationStatus: {
    booked: "Bestätigt",
    cancelled: "Storniert",
    pending: "Ausstehend",
    checked_in: "Eingecheckt",
    checked_out: "Ausgecheckt",
  },

  reservationPanel: {
    title: "Verknüpfte Buchung",
    stayEnded: "Der Gast wohnt nicht mehr hier",
    checkIn: "Check-in",
    checkOut: "Check-out",
    room: "Zimmer",
    reservation: "Buchung",
    phone: "Telefon",
    viewReservation: "Buchung ansehen",
    noReservationTitle: "Keine verknüpfte Buchung",
    noReservationOta:
      "Dieser Verlauf kam von {channel} über Channex und ist noch nicht mit einer lokalen Buchung verknüpft.",
    noReservationWhatsapp:
      "Dieser Kontakt hat an das verbundene WhatsApp geschrieben, ist aber noch nicht mit einer Buchung verknüpft.",
    assignReservation: "Buchung zuordnen",
    createReservation: "Buchung erstellen",
    assignExisting: "Bestehende Buchung zuordnen",
    searchPlaceholder: "Nach Name oder Code suchen...",
    noReservationsFound: "Keine Buchungen gefunden",
    placeholderContext: "Wählen Sie eine Konversation, um den Kontext zu sehen",
    propertyUnavailable: "Unterkunft nicht verfügbar",
  },

  contextMenu: {
    pin: "Konversation anheften",
    unpin: "Konversation lösen",
    archive: "Konversation archivieren",
    unarchive: "Archivierung aufheben",
  },

  waStatus: {
    read: "Gelesen",
    delivered: "Zugestellt",
    queued: "In Warteschlange",
    failed: "Fehlgeschlagen",
    sent: "Gesendet",
  },

  waFailTitle: {
    noWhatsapp: "Kein WhatsApp",
    invalidNumber: "Ungültige Nummer",
    notSent: "Nicht gesendet",
  },

  waErrors: {
    generic: "Diese Nachricht konnte nicht über WhatsApp gesendet werden.",
  },

  waErrorShort: {
    e131042: "Zahlungsproblem beim WhatsApp-Konto",
    e131026: "die Nummer kann kein WhatsApp empfangen",
    e131053: "WhatsApp konnte die Datei nicht herunterladen",
    e132000: "fehlende Daten in der Vorlage",
    e131009: "die Nachricht erfüllt nicht die Anforderungen von WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "Der KI-Agent ist aktiv. Wechseln Sie in den manuellen Modus, um zu antworten.",
    pinned: "Konversation angeheftet",
    unpinned: "Konversation gelöst",
    archived: "Konversation archiviert",
    unarchived: "Archivierung aufgehoben",
    reservationAssigned: "Buchung zugeordnet: {name}",
    reservationUnassigned: "Zuordnung der Buchung aufgehoben",
    selectPropertyToCreate:
      "Wählen Sie eine Unterkunft, um die Buchung aus diesem Chat zu erstellen.",
    userNotResolved: "Der Panel-Benutzer konnte nicht ermittelt werden.",
    aiNotEnabledConfig:
      "Für diese Unterkunft ist der KI-Agent nicht aktiviert. Aktivieren Sie ihn in den Einstellungen des Inserats.",
    aiEnabledForChat: "KI-Agent für diese Konversation aktiviert",
    manualEnabledForChat: "Manueller Modus für diese Konversation aktiviert",
    templateSent: "Vorlage erfolgreich gesendet.",
  },

  errors: {
    inboxNotActive:
      "Der Nachrichteneingang ist für dieses Konto nicht aktiv oder das Business-WhatsApp muss noch verbunden werden.",
    openConversation: "Die Konversation konnte nicht geöffnet werden",
    sendMessage: "Die Nachricht konnte nicht gesendet werden. Prüfen Sie Ihre WhatsApp-Verbindung.",
    pin: "Fehler beim Anheften der Konversation",
    archive: "Fehler beim Archivieren",
    loadReservations: "Fehler beim Laden der Buchungen",
    assignReservation: "Fehler beim Zuordnen der Buchung",
    unassignReservation: "Fehler beim Aufheben der Zuordnung",
    updateMode: "Der Modus für diese Konversation konnte nicht aktualisiert werden",
    reactivationTemplate: "Die Reaktivierungsvorlage konnte nicht gesendet werden.",
  },
};
